// @ts-nocheck
import SceneLayerMarker from "./marker";
import SceneMarker from "~/scene/marker/marker";

export default class SceneLayerMasakovac extends SceneLayerMarker {
	/**
	 * Vytvoreni masakovace.
	 */
	constructor(scene, itemId) {
		super(scene, itemId, null);

		this._TYPE_PRIORITY = ["detail", "search", "poi"];
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	// eslint-disable-next-line class-methods-use-this
	get featureInfo() {
		return {
			name: "SceneLayerMasakovac",
			type: "layer",
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		const rd = super.getCreateData();

		rd.markers = this._markers;

		return rd;
	}

	/**
	 * Pridani markeru.
	 *
	 * @param {string}  type     typ markeru dle this._TYPE_PRIORITY
	 * @param {object}  marker   marker
	 * @param {string}  source   source bodu
	 * @param {integer} id       id bodu
	 * @param {boolean} noRedraw zda se nema po pridani bodu hnedka prekreslit (defaultne se prekresluje)
	 */
	addMarker(type, marker, source, id, noRedraw) {
		const markers = [];
		let show = true;

		if (this._scene.isM3dActive() && (type === "poi" || arguments.length < 3) && source !== "foto" && source !== "ffoto") {
			return;
		}

		if (this._scene.isWasmActive() && (type === "poi" || arguments.length < 3)) {
			return;
		}

		if (arguments.length < 3) { // pokud je metoda volana s mene jak 4 argumenty, pocitame s tim, ze prvni argument je pole s markerama poiu
			if (Array.isArray(type)) {
				if (type.length === 0) { // pokud je pole prazdne koncime
					return;
				}

				for (let index = 0; index < type.length; index++) { // pokud pole neni prazdne, vytvorime z nich prislusny objekt a pokud neni v kolizi vlozime do mapy
					const combineID = `${type[index].getSource()}${type[index].getPlainId()}${type[index].getKey() === undefined ? "" : `-${type[index].getKey()}`}`;

					show = this._checkCollision("poi", type[index].getSource(), combineID);
					this._addMarker("poi", type[index], type[index].getSource(), combineID, show);
					show && markers.push(type[index]);
				}
			} else if (type instanceof SceneMarker) { // pokud bude nekdo volat jako postaru s jednim argumentem, ale neni to pole, bereme automaticky, ze je to poi
				const combineID = `${type.getSource()}${type.getPlainId()}${type.getKey() === undefined ? "" : `-${type.getKey()}`}`;

				show = this._checkCollision("poi", type.getSource(), combineID);
				this._addMarker("poi", type, type.getSource(), combineID, show);
				show && markers.push(type);
			}
		} else { // vlozeni jednoho markeru s typem, zjistime zda neni v kolizi a zda se ma vlozit
			const combineID = `${source}${id}${marker.getKey() === undefined ? "" : `-${marker.getKey()}`}`;

			show = this._checkCollision(type, source, combineID);
			this._addMarker(type, marker, source, combineID, show);
			show && markers.push(marker);
		}

		// pouzijeme layer marker
		markers.length && this._onChange(this._scene.featureEvent("layerMasakovacChangeMarkers", true, true), [this.getMarkers(undefined, true), noRedraw]);
	}

	/**
	 * Odebrani markeru.
	 *
	 * @param  {object}  marker   marker
	 * @param  {boolean} noRedraw zda se nema po odebrani bodu prekreslit (defaultne se prekresluje)
	 */
	removeMarker(marker, noRedraw) {
		const markers = marker instanceof Array ? marker : [marker];

		if (markers.length === 0) { // pokud je pole prazdne koncime
			return;
		}

		// pokud pole neni prazdne, najdeme prislusny a odebereme
		for (let index = 0; index < markers.length; index++) {
			const id = markers[index].getId();

			if (!this._markers[id]) {
				continue;
			}

			const markerType = this._markers[id].type;
			const source = this._markers[id].source;
			const markerId = this._markers[id].id;

			this._removeMarker(this._markers[id]);
			this._checkPrevMarker(markerType, source, markerId);
		}

		// TODO WASM
		if (this._scene.isWasmActive()) {
			this._onChange(this._scene.featureEvent("layerMarkerRemoveMarkers", true, true), [[marker], noRedraw]);
		} else {
			this._onChange(this._scene.featureEvent("layerMasakovacChangeMarkers", true, true), [this.getMarkers(undefined, true), noRedraw]);
		}
	}

	/**
	 * Odebere vsechny markery daneho typu.
	 *
	 * @param  {string} type typ markeru dle this._TYPE_PRIORITY
	 */
	removeAll(type) {
		const markers = [];

		if (type) { // pokud je dany typ, smazeme jen markery daneho typu
			for (const param in this._markers) {
				if (param in this._markers) {
					if (this._markers[param].type === type) {
						const markerObj = this._markers[param];
						const source = markerObj.source;
						const id = markerObj.id;

						// budeme odstranovat jen pokud byl marker ve vrstve
						markerObj.show && markers.push(markerObj.marker);

						this._removeMarker(markerObj);
						this._checkPrevMarker(type, source, id);
					}
				}
			}
		} else {
			for (const param in this._markers) {
				if (param in this._markers) {
					// budeme odstranovat jen pokud byl marker ve vrstve
					this._markers[param].show && markers.push(this._markers[param].marker);

					this._removeMarker(this._markers[param]);
				}
			}
		}

		markers.length && this._onChange(this._scene.featureEvent("layerMasakovacChangeMarkers", true, true), [this.getMarkers(undefined, true)]);
	}

	/**
	 * Nastavi vsem POIum stav. Jestli to nejak lepe pojmenovat?
	 * Pouzite u poiu pro pruhlednost.
	 */
	allPOIState(...args) {
		this._onChange(this._scene.featureEvent("layerMasakovacAllPOIState", true, true), args);
	}

	/**
	 * Pridani markeru.
	 *
	 * @param {String} type Typ
	 * @param {SceneMarker} marker Marker
	 * @param {String} source Zdroj markeru
	 * @param {Number} id ID markeru
	 * @param {Boolean} show Zobrazit marker?
	 */
	_addMarker(type, marker, source, id, show) {
		const markers = Array.isArray(marker) ? marker : [marker];

		for (let index = 0; index < markers.length; index++) {
			const item = markers[index];
			const obj = { /* polozka do marker cache */
				marker: item, /* znacka */
				type: type,
				source: source,
				id,
				show: show,
			};

			if (!this._interaction) {
				item.setActive(false);
			}

			this._markers[item.getId()] = obj;

			item.appended = true;
			item.sceneOwner = this;
		}
	}

	_removeMarker(marker) {
		const id = marker?.marker?.getId();

		if (!id || !(id in this._markers)) {
			return;
		}

		marker.marker.appended = false;
		marker.marker.sceneOwner = null;

		delete this._markers[id];
	}

	/**
	 * Vrati vsechny markery daneho typu.
	 *
	 * @param  {string} type typ markeru dle this._TYPE_PRIORITY
	 * @return {array}      pole markeru
	 * @private
	 */
	_getTypeMarkers(type) {
		const typeMarkers = [];

		for (const marker in this._markers) {
			if (this._markers[marker].type === type) {
				typeMarkers.push(this._markers[marker]);
			}
		}

		return typeMarkers;
	}

	/**
	 * Kotntrola kolizi pri pridavani markeru.
	 *
	 * @param  {string}  type   typ markeru dle this._TYPE_PRIORITY
	 * @param  {object}  marker marker
	 * @param  {string}  source source bodu
	 * @param  {integer} id     id bodu
	 * @return {boolean}        doslo ke kolizi
	 */
	_checkCollision(type, source, id) {
		const actualTypeIndex = this._TYPE_PRIORITY.indexOf(type); // zjistime index v poli s prioritama

		if (actualTypeIndex > -1) { // pokud typ existuje projdeme kolize
			for (let typeIndex = 0; typeIndex < this._TYPE_PRIORITY.length; typeIndex++) {
				if (this._TYPE_PRIORITY[typeIndex] === type) { // stejny typ jako je znacka preskocime
					continue;
				}

				const searchType = this._getTypeMarkers(this._TYPE_PRIORITY[typeIndex]);// pole ve kterem se hleda kolize, jeden typ

				for (let index = 0; index < searchType.length; index++) {
					const item = searchType[index];

					if (source === item.source && id === item.id) { // shoduji se
						if (typeIndex < actualTypeIndex) { // index je mensi nez pridavane znacky, nebudeme se zobrazovat a hledani kolizi ukoncime
							return false;
						}

						item.show = false; // nasli jsme kolizi, ale ma vetsi index, tak danou znacku zakazeme
						item.marker.removeCard();
						//this._onChange(this._scene.featureEvent("layerMarkerRemoveMarkers", true, true), [[item.marker], true]);

						return true;
					}
				}
			}
		}

		return true; // nedoslo ke kolizi zobrazime se
	}

	/**
	 * Kontrola zda odebirana znacka nebyla s nekym v kolizi.
	 *
	 * @param  {string}  type   typ markeru dle this._TYPE_PRIORITY
	 * @param  {object}  marker marker
	 * @param  {string}  source source bodu
	 * @param  {integer} id     id bodu
	 */
	_checkPrevMarker(type, source, id) { // kontrola zda odebirana znacka nebyla s nekym v kolizi
		let actualTypeIndex = this._TYPE_PRIORITY.indexOf(type); // zjistime index v poli s prioritama

		if (actualTypeIndex > -1) {
			actualTypeIndex++; // zacneme na skupine s vyssim indexem

			while (actualTypeIndex < this._TYPE_PRIORITY.length) {
				const actualtype = this._TYPE_PRIORITY[actualTypeIndex];

				if ((!this._scene.isM3dActive() && !this._scene.isWasmActive()) || (this._scene.isM3dActive() && actualtype !== "poi")) {
					const searchType = this._getTypeMarkers(actualtype);

					if (actualtype !== type) {
						for (let index = 0; index < searchType.length; index++) {
							const item = searchType[index];

							if (item.source === source && item.id === id) { // pokud najdu shodu zobrazim a ukoncim hledani
								item.show = this._checkCollision(item.type, item.source, item.id);
								//item.show && this._onChange(this._scene.featureEvent("layerMarkerAddMarkers", true, true), [[item.marker], true]);

								return;
							}
						}
					}
				}

				actualTypeIndex++; // dale hledame jen v typech s nizsi prioritou (vyssim indexem)
			}
		}
	}

	/**
	 * Vrati vsechny markery nebo markery daneho typu.
	 *
	 * @param  {string|array} type typ markeru dle this._TYPE_PRIORITY
	 * @param  {boolean} onlyShow jen ty, ktere se maji zobrazit v mape
	 * @return {array}      pole markeru
	 */
	getMarkers(type, onlyShow) {
		const result = [];
		let types = this._TYPE_PRIORITY.slice().reverse();

		types.splice(0, this._scene.isM3dActive() ? 1 : 0);

		if (type) {
			types = type instanceof Array ? type : [type];
		}

		for (let typeIndex = 0; typeIndex < types.length; typeIndex++) {
			const typeMarkers = this._getTypeMarkers(types[typeIndex]);

			for (let index = 0; index < typeMarkers.length; index++) {
				if (!onlyShow || typeMarkers[index].show) {
					result.push(typeMarkers[index].marker);
				}
			}
		}

		return result;
	}

	/**
	 * Ziskani pole se vsemi markery.
	 *
	 * @return {Array[SceneMarker]}
	 */
	getMarkersList() {
		const items = [];

		for (const id in this._markers) {
			if (id in this._markers) {
				items.push(this._markers[id]);
			}
		}

		return items;
	}
}
